import { Reveal, Overline } from "./Reveal";
import { BENEFITS } from "@/data/content";

export const Benefits = () => (
  <section data-testid="benefits-section" className="py-24 sm:py-32">
    <div className="mx-auto grid max-w-6xl gap-14 px-5 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Overline>What You Gain</Overline>
            <h2 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
              What You Gain Through Mentoring
            </h2>
            <p className="mt-4 text-base leading-relaxed text-ink-muted">
              Real shifts you can feel in your work, your decisions, and your everyday life.
            </p>
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-8">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.05}>
            <div
              data-testid={`benefit-row-${i}`}
              className="group flex items-start gap-6 border-t border-peach/20 py-7 transition-[background-color,padding] duration-500 last:border-b hover:bg-cream-dark/60 hover:pl-3"
            >
              <span className="font-display text-3xl tracking-wide text-peach-dark/60 transition-colors duration-500 group-hover:text-peach-dark">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="flex items-center gap-3 font-heading text-lg font-bold text-ink">
                  <b.icon size={18} className="text-peach-dark" strokeWidth={1.8} />
                  {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-muted sm:text-base">{b.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
